<template>
  <div>
    <div v-if="field.type === 'checkbox'" class="checkbox-field sunken-block">
      <span>{{ field.label }}</span>
      <v-simple-checkbox :value="values[field.name] == '1'"
                         @input="updateValue(field.name, $event)">
      </v-simple-checkbox>
    </div>

    <component
        v-if="field.type !== 'checkbox'"
        :is="getFieldComponent(field.type)"
        :value="values[field.name]"
        @input="updateValue(field.name, $event)"
        v-bind="getFieldProps(field)"
        @filesReady="filesReady"
    />

    <div v-if="field.type === 'image' && field.preview && values[field.preview]" class="image-current">
      <div class="v-label mb-2">{{ field.previewLabel || 'تصویر فعلی' }}</div>
      <div class="image-current__frame">
        <img :src="values[field.preview]" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import TextEditor from "@/components/General/TextEditor.vue";
import ImageUploader from "@/components/File/ImageUploader.vue";
import VTextField from "vuetify/lib/components/VTextField"
import VSelect from "vuetify/lib/components/VSelect"
import VCheckbox from "vuetify/lib/components/VCheckbox"

export default {
  name: "FieldRenderer",
  data() {
    return {
      asdasd: true
    }
  },
  components: {
    TextEditor,
    ImageUploader,
    VTextField,
    VSelect,
    VCheckbox,
  },
  props: {
    field: Object,
    values: Object
  },
  methods: {
    /** Determines the correct component for the field type */
    getFieldComponent(type) {
      const componentMap = {
        text: "v-text-field",
        number: "v-text-field",
        ckeditor: "TextEditor",
        image: "ImageUploader",
        select: "v-select",
      };
      return componentMap[type] || "v-text-field"; // Default to text field
    },

    /** Returns dynamic props based on field type */
    getFieldProps(field) {
      let props = {
        label: field.label,
        color: "#00ADB5",
        outlined: true,
      };

      if (field.type === "number") {
        props.type = "number";
        props.min = field.min ?? 0;
      }

      if (field.type === "select") {
        props.items = field.select_items;
        props["item-value"] = field.select_value;
        props["item-text"] = field.select_text;
        props.clearable = true;
      }

      if (field.type === "ckeditor") {
        props.name = field.name;
        props.label = field.label;
        props.direction = field.direction;
        props.clearable = true;
      }


      if (field.type === "image") {
        props.name = field.name;
      }

      return props;
    },

    /** Emits the updated value to the parent */
    updateValue(fieldName, value) {
      this.$emit("input", {name: fieldName, value});
    },

    filesReady(file, name) {
      this.$emit("input", {name: name, value: file});
    },
  }
};
</script>

<style>
.tox {
  margin-bottom: 20px !important;
}

.image-current {
  margin: 16px 0 8px;
}

.image-current__frame {
  height: 200px;
  border-radius: var(--radius-md);
  border: 1px solid rgba(238, 238, 238, 0.12);
  background: #fff;
  overflow: hidden;
}

.image-current__frame img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 8px;
}

.checkbox-field {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  margin-bottom: 26px;
}
</style>